import createReducer from 'utils/createReducer';
import {
    SET_CLOSED_CAPTIONS_LOADED,
    TOGGLE_CLOSED_CAPTIONS,
} from '../actions/closedCaptions';

const initialState = {
    isLoaded: false,
    isEnabled: false,
};

const handlers = {
    [TOGGLE_CLOSED_CAPTIONS]: (state, { payload }) => {
        return { ...state, isEnabled: payload };
    },
    [SET_CLOSED_CAPTIONS_LOADED]: (state, { payload }) => {
        return { ...state, isLoaded: payload };
    },
};

export default createReducer(initialState, handlers);
